import { TranslationService } from '../../../../services/translation.service';

function FeedbackRequested({
  id,
  feedbackRequested,
  className = '',
  onFeedbackRequestedChange,
}: {
  id: string;
  feedbackRequested: boolean;
  className?: string;
  onFeedbackRequestedChange: (feedbackRequested: boolean) => void;
}) {
  return (
    <div id={id} className={`request-feedback ${className}`}>
      <fieldset>
        <legend className="h4 mb-3">{TranslationService.get('customerserviceforms.contactinformation.requestfeedback')}</legend>
        <div className="form-check">
          <input id={`${id}-checkbox`} checked={feedbackRequested} onChange={(e) => onFeedbackRequestedChange(e.target.checked)} type="checkbox" className="form-check-input" />
          <label className="form-check-label fw-normal" htmlFor={`${id}-checkbox`}>
            {TranslationService.get('customerserviceforms.contactinformation.requestfeedbacklabel')}
          </label>
        </div>
      </fieldset>
    </div>
  );
}

export default FeedbackRequested;
